import {
  normalizeQuantityOptions,
  createQuantityOptions,
  QuantityOption,
} from "../../../domain/policies/quantityPolicy";

import { IFlagsmithFeature } from "flagsmith/types";

export class GetQuantityOptionsUseCase {
  constructor(private readonly flags: IFlagsmithFeature) {}

  execute(): QuantityOption[] {
    const raw = this?.flags?.value;

    const fromFlag = normalizeQuantityOptions(raw, {
      includeZero: true,
      zeroLabel: "0", // Selecione uma opção
    });
    if (fromFlag && fromFlag.length > 0) return fromFlag;

    return createQuantityOptions({
      max: 20,
      includeZero: true,
      zeroLabel: "0",
      unitLabel: (n) => `${n}.000`,
    });
  }
}
